/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { gatherCartesianProductsForBOM } from "../../Cartesian/func.utils";
import { gatherIntegratedDrivesProductsForBOM } from "../../IntegratedDrives/func.utils";
import { gatherMc12ProductsForBOM } from "../../Mc12/func.utils";
import { gatherRetrofitProductsForBOM } from "../../Retrofit/func.util";

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL
});

const axiosInstanceMail = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL
});

const axiosInstanceTechnologies = axios.create({
  withCredentials: false,
  baseURL: `${process.env.REACT_APP_STATIC_FILES_URL}/technologies/`
});

const axiosInstanceFilters = axios.create({
  withCredentials: false,
  baseURL: `${process.env.REACT_APP_STATIC_FILES_URL}/filters/`
});

const axiosInstanceProductsDescriptions = axios.create({
  withCredentials: false,
  baseURL: process.env.REACT_APP_PRODUCTS_DESCRIPTIONS_URL
});

const axiosInstanceDocumentation = axios.create({
  withCredentials: false
});

const axiosInstanceProducts = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_PRODUCTS_URL
});

export const API_INSTANCE = axios.create({});
const axiosInstanceNotifications = axios.create({
  withCredentials: false,
  baseURL: `${process.env.REACT_APP_STATIC_FILES_URL}/notifications/`
});

const axiosInstanceSurveyData = axios.create({
  withCredentials: false,
  baseURL: `${process.env.REACT_APP_STATIC_FILES_URL}/surveys/`
});

export default {
  axiosInstance,
  axiosInstanceMail,
  axiosInstanceTechnologies,
  axiosInstanceFilters,
  axiosInstanceProducts
};

export const endpointPrefixes = {
  RETROFIT: "",
  CARTESIAN: "cartesian-",
  MC12: "mc12-",
  INTEGRATED_DRIVES: "integrated-drives-"
};

const getEndpointPrefix = (configurationType) => {
  switch (configurationType) {
    case "MC12":
      return endpointPrefixes.MC12;
    case "CARTESIAN":
      return endpointPrefixes.CARTESIAN;
    case "RETROFIT":
      return endpointPrefixes.RETROFIT;
    case "INTEGRATED_DRIVES":
      return endpointPrefixes.INTEGRATED_DRIVES;
    default:
      return endpointPrefixes.RETROFIT;
  }
};

const downloadURI = (uri) => {
  const link = document.createElement("a");
  link.href = uri;
  if (!link.onclick) window.open(link.href, link.target || "_self");
  else link.click();
};

// export BOM in xls
export async function exportXls(id, type) {
  try {
    const lang = window.msizerConfiguration.locale || "en-WW";
    const response = await axiosInstance.get(`/configurations/${id}/exportXls?locale=${lang}&type=${type}`, {
      withCredentials: true
    });
    downloadURI(process.env.REACT_APP_XLS_URL_PREFIX + response.data.payload);

    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

// export HiveFile as XML
export async function exportHiveFileXML(id, type, download) {
  try {
    const lang = window.msizerConfiguration.locale || "en-WW";
    const response = await axiosInstance.get(
      `/configurations/${id}/exportHiveFile?locale=${lang}&type=${type}&download=${download}`,
      {
        withCredentials: true
      }
    );
    if (download === "yes") {
      downloadURI(process.env.REACT_APP_XLS_URL_PREFIX + response.data.payload);
    }
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function exportHiveFileZIP(id, type, download) {
  try {
    const lang = window.msizerConfiguration.locale || "en-WW";
    const response = await axiosInstance.get(
      `/configurations/${id}/exportIntegratedDrivesHiveFile?locale=${lang}&type=${type}&download=${download}`,
      {
        withCredentials: true
      }
    );
    if (download === "yes") {
      downloadURI(process.env.REACT_APP_XLS_URL_PREFIX + response.data.payload);
    }
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function generateHiveFileXML(id, type) {
  try {
    const lang = window.msizerConfiguration.locale || "en-WW";
    const response = await axiosInstance.get(`/configurations/${id}/exportHiveFile?locale=${lang}&type=${type}`, {
      withCredentials: true
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getAccessories(payload) {
  try {
    const response = await axiosInstance.get("/accessories", {
      params: { ...payload }
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getTechnologiesScope() {
  try {
    const response = await axiosInstanceTechnologies.get("/technologies_scope.json?");
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getFiltersValues() {
  try {
    const response = await axiosInstanceFilters.get("/filtersValues.json");
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getCartesianFiltersValues() {
  try {
    const response = await axiosInstanceFilters.get("/cartesianFiltersValues.json");
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getNotifications() {
  try {
    const response = await axiosInstanceNotifications.get("/notifications.json");
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getSurveyData(surveyType) {
  try {
    const response = await axiosInstanceSurveyData.get(`/${surveyType}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getSession() {
  try {
    const response = await axiosInstance.get("/sessions");
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getBundles(params) {
  try {
    const response = await axiosInstance.post("/bundles", params);
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getIntegratedDrivesBundles(params) {
  try {
    const response = await axiosInstance.post("/integrated-drives-bundle", params);
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function saveConfiguration(params) {
  //console.log("saveConfiguration");
  //console.log(params);
  try {
    const { configurationType } = params;
    const endpointPrefix = getEndpointPrefix(configurationType);
    const response = await axiosInstance.post(`/${endpointPrefix}configurations`, params, {
      withCredentials: true
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function updateConfigurationApi(id, params) {
  //console.log("updateConfigurationApi");
  //console.log(id, params);
  try {
    const { configurationType } = params;
    const endpointPrefix = getEndpointPrefix(configurationType);
    const response = await axiosInstance.put(`/${endpointPrefix}configurations/${id}`, params, {
      withCredentials: true
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

// Function to get configurations for a specific endpoint prefix
async function getConfigurationsForPrefix(prefix) {
  try {
    const response = await axiosInstance.get(`/${prefix}configurations`, {
      withCredentials: true
    });
    return response.data.payload.configurations;
  } catch (error) {
    console.error(`Failed to fetch configurations for ${prefix}:`, error);
    return null;
    // throw error;
  }
}

// get all saved configurations
// export async function getSavedConfigurations() {
//   try {
//     const configurationPromises = Object.values(endpointPrefixes).map((prefix) =>
//       getConfigurationsForPrefix(prefix)
//     );

//     const configurations = await Promise.all(configurationPromises);
//     // const combineConfigurations = [].concat(...configurations);
//     // // sort by updatedDate
//     // const sortedConfigurations = combineConfigurations.sort((a, b) =>
//     //    a.updatedDate > b.updatedDate
//     // );
//     // return sortedConfigurations;
//     return configurations;
//   } catch (error) {
//     console.error('Failed to fetch configurations:', error);
//     return Promise.reject(error);
//   }
// }

export async function getSavedConfigurations() {
  try {
    const configurationPromises = Object.entries(endpointPrefixes).map(async ([key, prefix]) => {
      const configurations = await getConfigurationsForPrefix(prefix);
      return { [key]: configurations };
    });

    const configurationsObject = {};

    // Wait for all promises to resolve and update the configurations object
    await Promise.all(configurationPromises).then((configurationsArray) => {
      configurationsArray.forEach((configurations) => {
        const key = Object.keys(configurations)[0];
        configurationsObject[key] = configurations[key];
      });
    });

    return configurationsObject;
  } catch (error) {
    console.error("Failed to fetch configurations:", error);
    return Promise.reject(error);
  }
}

export async function getSavedConfigurationById(params) {
  try {
    const { id } = params;
    const response = await axiosInstance.get(`/all-configurations/${id}`, {
      withCredentials: true
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function syncFiltersDependencies(configurationType, params) {
  try {
    let endpointPrefix = getEndpointPrefix(configurationType);
    if (configurationType === "CARTESIAN") {
      endpointPrefix = "";
    }
    const response = await axiosInstance.post(`/${endpointPrefix}dependencies`, params);
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function shareByMail(params) {
  const { emailData, configId } = params;
  try {
    const lang = window.msizerConfiguration.locale || "en-WW";
    const response = await axiosInstanceMail.post(`/configurations/${configId}/share?locale=${lang}`, emailData, {
      withCredentials: true
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getProductsDescriptions(params) {
  try {
    const lang = window.msizerConfiguration.locale || "en-WW";
    const response = await axiosInstanceProductsDescriptions.post(
      `/description/locale/${lang}`,
      {
        refIds: params
      },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer afNuEJRXrfP8QqIlz_z1m0mWvKfAGK7W"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

// get commercialized refs
export async function getCommercializedRefs(params, locale) {
  try {
    const response = await axiosInstance.post(`/commercializedProducts?locale=${locale}`, {
      listOfProducts: params
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

// Get documentation
export const getDocumentation = async (params) => {
  try {
    const lang = window.msizerConfiguration.locale || "en-WW";
    const response = await axiosInstanceDocumentation.post(
      `https://www.se.com/ww/confsdl/msx-api/documentation?locale=${lang}`,
      { referenceIds: params }
    );
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

// export async function getDocumentation(params) {
//   try {
//     const lang = window.msizerConfiguration.locale || "en-WW";
//     const response = await axiosInstanceDocumentation.post(
//       `${urlDocumentation}/documentation?locale=${lang}`,
//       {
//         referenceIds: params
//       }
//     );
//     return response.data.payload;
//   } catch (error) {
//     console.error(error);
//     return Promise.reject(error);
//   }
// }

/* ADD TO MY PRODUCTS */

const discoverBaseApiUrl = () => {
  const { origin } = window.location;
  // const { lang, country } = getAppLocaleAsObject();
  const locale = window.msizerConfiguration?.locale || "en-WW";
  const { lang, country } = {
    lang: locale?.split("-")?.[0],
    country: locale?.split("-")?.[1]
  };
  const correctedCountry = country === "GB" ? "UK" : country;
  let result;
  // The URL for adding a configuration to My Products depends on the domain the application is run on.
  if (origin.match(/\bse\.com$/) || origin.match(/\bpre\.se\.com$/)) {
    // Single domain: post to https://www.se.com/ru/ru/product/my-products.
    result = `${origin}/${correctedCountry.toLowerCase()}/${lang.toLowerCase()}`;
  } else if (origin.match(/\bschneider-electric\b/)) {
    // A locale-specific domain: post to https://www.schneider-electric.com.au/en/product/my-products.
    result = `${origin}/${lang.toLowerCase()}`;
  } else {
    // It's workaround solution for local/pre-prod/sqe/dev etc env's
    result = `https://www.schneider-electric.${correctedCountry.toLowerCase() === "ww" ? "com" : correctedCountry.toLowerCase()
      }/${lang.toLowerCase()}`;
  }
  return result;
};

// Helper function to build product objects with a specific quantity
function buildProductObject(productId, descriptions, locale, products, quantity) {
  const existingProduct = products.find((product) => product.productId === productId);
  if (existingProduct) {
    // If the product already exists, update its quantity
    existingProduct.quantity = quantity;
    return existingProduct;
  } else {
    // Find the product description once and reuse it
    const productDescription = descriptions.find((p) => p.catalogue_product.id === productId)?.catalogue_product
      ?.long_desc;
    const description = productDescription?.translation?.[locale] || productDescription?.translation?.["en-GB"];

    // If the product does not exist, create a new product object with the specified quantity
    return {
      productId,
      description,
      pictureUrl: `https://gw-api.schneider-electric.com/sc/products/image/${productId}?width=100&height=100`,
      quantity: quantity
    };
  }
}

function getAppropriateDescription(productId, descriptions, locale) {
  const productDescription = descriptions.find((p) => p.catalogue_product.id === productId)?.catalogue_product
    ?.long_desc;
  return productDescription?.translation?.[locale] || productDescription?.translation?.["en-GB"]
}

// eslint-disable-next-line no-unused-vars
const extractProductsFromConfiguration = async (configuration) => {
  // console.log("extractProductsFromConfiguration");
  const { configurationType } = configuration?.configData;
  let gatheredProducts = [];
  if (configurationType === "RETROFIT") {
    const { axes } = configuration?.configData;
    gatheredProducts = gatherRetrofitProductsForBOM(axes);

  } else if (configurationType === "CARTESIAN") {
    gatheredProducts = await gatherCartesianProductsForBOM(configuration.configId);

  } else if (configurationType === "MC12") {
    const { track } = configuration?.configData;
    gatheredProducts = gatherMc12ProductsForBOM(track);
  } else if (configurationType === "INTEGRATED_DRIVES") {
    const { axes } = configuration?.configData;
    gatheredProducts = gatherIntegratedDrivesProductsForBOM(axes);
  }
  return gatheredProducts;
};
export async function addToMyProducts(params) {
  console.log("addToMyProducts");
  const configuration = params;
  const locale = window.msizerConfiguration?.locale || "en-WW";
  const country = locale?.split("-")?.[1] || "WW";
  const baseApiUrl = discoverBaseApiUrl();
  const favoritesUrl = `${baseApiUrl}/product/my-products`;
  const extractedProducts = await extractProductsFromConfiguration(configuration);
  const descriptions = await getProductsDescriptions(extractedProducts.map((product) => product.commercialReference));
  console.log(extractedProducts);
  // TODO : if is iframe => add to distributor card else add to my product
  if (window.self !== window.top) {
    console.log("From Iframe");
    try {
      window.parent.postMessage( // iframe
        {
          type: "ScWidgetSaveConfigurationEvent",
          options: {
            configurationMasterId: configuration.configId,
            locale,
            country,
            // replace each productId by reference
            products: extractedProducts.map((product) => ({
              reference: product.commercialReference,
              quantity: product.quantity,
              pictureUrl: `https://gw-api.schneider-electric.com/sc/products/image/${product.commercialReference}?width=100&height=100`,
              description: getAppropriateDescription(product.commercialReference, descriptions, locale)
            })),
            grouping: {
              enable: true,
              backURL: `${window.location.href.split("?")[0]}?configuration=${configuration.configId}`,
              configurationMasterId: configuration.configId,
              displayName: configuration.configData?.configName
            },
            options: { allowPartialAdding: true, source: "MSIZER" }
          }
        },
        "*"
      );
    } catch (error) {
      console.error(error);
    }
  } else {
    console.log("From Standalone (add to favorites)");
    try {
      await API_INSTANCE.post(favoritesUrl, {
        products: extractedProducts.map((product) => ({
          productId: product.commercialReference,
          quantity: product.quantity,
          pictureUrl: `https://gw-api.schneider-electric.com/sc/products/image/${product.commercialReference}?width=100&height=100`,
          description: getAppropriateDescription(product.commercialReference, descriptions, locale)
        })),
        grouping: {
          enable: true,
          backURL: `${window.location.href.split("?")[0]}?configuration=${configuration.configId}`,
          configurationMasterId: configuration.configId,
          displayName: configuration.configData?.configName
        },
        options: { allowPartialAdding: true, source: "MSIZER" }
      }, false);
    } catch (error) {
      console.error(error);
    }
  }
}

export async function addToMyProject(params) {
  console.log("addToMyProject");
  const configuration = params;
  const locale = window.msizerConfiguration?.locale || "en-WW";
  const country = locale?.split("-")?.[1] || "WW";
  const extractedProducts = await extractProductsFromConfiguration(configuration);
  const descriptions = await getProductsDescriptions(extractedProducts.map((product) => product.commercialReference));
  try {
    if (configuration.configData?.configurationType === "RETROFIT" || configuration.configData?.configurationType === "MC12" || configuration.configData?.configurationType === "INTEGRATED_DRIVES"
    ) {
      console.log("RETROFIT & MC12");
      const eventDetail = {
        configurationMasterId: configuration.configId,
        locale,
        country,
        products: extractedProducts.map((product) => ({
          productId: product.commercialReference,
          quantity: product.quantity,
          pictureUrl: `https://gw-api.schneider-electric.com/sc/products/image/${product.commercialReference}?width=100&height=100`,
          description: getAppropriateDescription(product.commercialReference, descriptions, locale)
        })),
        grouping: {
          enable: true,
          backURL: `${window.location.href.split("?")[0]}?configuration=${configuration.configId}`,
          configurationMasterId: configuration.configId,
          displayName: configuration.configData?.configName
        },
        options: { allowPartialAdding: true, source: "MSIZER" }
      }
      console.log(eventDetail);
      if (window.self !== window.top) {
        console.log("From Iframe");
        window.parent.postMessage(
          {
            type: "ScWidgetSaveConfigurationEvent",
            options: {
              ...eventDetail,
              products: eventDetail.products.map((product) => {
                const newProduct = { ...product };
                delete newProduct.productId;
                newProduct.reference = product.productId;
                return newProduct;
              })
            }
          },
          "*"
        );
      } else {
        console.log("From Standalone");
        document.dispatchEvent(
          new CustomEvent(// seamlessToken = "kdqml" => myschneider (mode connecté)
            window.msizerConfiguration.seamlessToken ? "MSIZER_ADD_TO_MY_PROJECT" : "PJ_IAC_ADD_TO_MY_PROJECT",
            {
              bubbles: true,
              detail: eventDetail
            }
          )
        );
      }
    } else if (configuration.configData?.configurationType === "CARTESIAN") {
      console.log("CARTESIAN Event");
      const hiveFile = await exportHiveFileXML(configuration?.configId, configuration?.configData?.configurationType, "no");
      const hiveFileContent = hiveFile ? hiveFile.hivefile : "";
      const ctoProduct = extractedProducts.find((product) => product.type === "cto");
      const eventDetail = {
          application_name: "CARTESIAN",
          locale,
          country,
          name: configuration.configData?.configName,
          products: [{
            partType: "cto",
            productId: ctoProduct?.commercialReference,
            description: null,
            freezeItem: true,
            isParent: true,
            quantity: ctoProduct?.quantity,
            groupId: "1",
            reloadData: {
                reloadSolution: configuration.configId,
                reloadConfiguration: false,
            },
            orderingData: {
              orderingId: null,
              hive2: hiveFileContent,
              hive2Url: null,
              productCode: null,
              edi: null
            },
            subparts:
              extractedProducts.filter((product) => product.type === "subpart" || (product.type === "nonCto" && product.productType !== "Drive")).map((product) => ({
                productId: product.commercialReference,
                description: getAppropriateDescription(product.commercialReference, descriptions, locale),
                quantity: product.quantity,
              }))
          },
          ...extractedProducts.filter((product) => product.type === "nonCto" && product.productType === "Drive").map((product) => ({
            partType: "nonCto",
            productId: product.commercialReference,
            description: getAppropriateDescription(product.commercialReference, descriptions, locale),
            quantity: product.quantity,
            freezeItem: false,
            isParent: false,
            subparts: []
          }))
          ]
      }
      console.log(eventDetail);
      if (window.self !== window.top) {
        console.log("From Iframe");
        window.parent.postMessage(
          {
            type: "ScWidgetSaveConfigurationEvent",
            options: eventDetail
          },
          "*"
        );
      } else {
        console.log("From Standalone");
        document.dispatchEvent(
          new CustomEvent(
            window.msizerConfiguration.seamlessToken ? "ADD_TO_PROJECT_BOM" : "PJ_IAC_ADD_TO_MY_PROJECT",
            {
              bubbles: true,
              detail : eventDetail
            }
          )
        );
      }

    }
  } catch (error) {
    console.error(error);
  }
}

export function getProductImgUrl(commercialReference, width = 100, height = 100) {
  return `https://gw-api.schneider-electric.com/sc/products/image/${commercialReference}?width=${width}&height=${height}`;
}

export async function logEvent(locale, type, tag, configId, params) {
  try {
    const response = await axiosInstance.post(
      // "/log/event?locale=fr-FR&type=START_CONFIG_EXAMPLE&tag=configuration_editor&id=245fde25-ca95-4c27-9f42-af793f5d3774",
      `/log/event?locale=${locale}&type=${type}&tag=${tag}&id=${configId}`,
      params
    );
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function logSurveyEvent(locale, type, tag, configId, params) {
  try {
    const response = await axiosInstance.post(
      `/log/survey-event?locale=${locale}&type=${type}&tag=${tag}&id=${configId}`,
      params
    );
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getProductInformations(ids) {
  try {
    const lang = window.msizerConfiguration.locale || "en-WW";
    const urlProductInfos = `/sc/v2.5/products/locale/${lang}?image=false&tabularDetails=false`;
    const parameters = {
      refIds: ids
    };
    const headersConfig = {
      "content-type": "application/json",
      Authorization: "Bearer afNuEJRXrfP8QqIlz_z1m0mWvKfAGK7W"
    };
    const response = await axiosInstanceProducts.post(urlProductInfos, parameters, { headers: headersConfig });
    return response.data;
  } catch (error) {
    console.log("Error", error);
    return Promise.reject(error);
  }
}
